<template>
  <div class="profile-container">
    <div class="profile-card">
      <img src="@/assets/user-avatar.png" alt="User Avatar" class="avatar" />
      <h2 class="username">{{ user.username }}</h2>
      
      <div class="info-section">
        <p><i class="fas fa-user"></i> <strong>Full Name:</strong> {{ fullName }}</p>
        <p><i class="fas fa-envelope"></i> <strong>Email:</strong> {{ user.email || "Not provided" }}</p>
        <p><i class="fas fa-phone"></i> <strong>Phone:</strong> {{ user.phoneNumber || "Not provided" }}</p>
      </div>

      <div class="role-section">
        <h4>Roles</h4>
        <span v-for="role in user.roles" :key="role.id" class="badge badge-primary">
          {{ role.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { AuthApi } from '../api';

export default {
  data() {
    return {
      user: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        username: "",
        roles: []
      },
    };
  },
  computed: {
    fullName() {
      return (this.user.firstName && this.user.lastName) 
        ? `${this.user.firstName} ${this.user.lastName}` 
        : "Not provided";
    }
  },
  async created() {
    try {
      const response = await AuthApi.getProfile();
      this.user = response;
    } catch (error) {
      console.error("Error fetching profile:", error);
    }
  }
};
</script>

<style scoped>
.profile-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f8f9fa;
}

.profile-card {
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  width: 400px;
}

.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-bottom: 15px;
  border: 3px solid #007bff;
}

.username {
  color: #333;
  font-size: 24px;
  margin-bottom: 10px;
}

.info-section {
  text-align: left;
  margin-bottom: 20px;
}

.info-section p {
  margin: 5px 0;
  font-size: 16px;
  color: #555;
}

.info-section i {
  margin-right: 10px;
  color: #007bff;
}

.role-section h4 {
  margin-bottom: 10px;
  color: #007bff;
}

.badge {
  background-color: #007bff;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  margin: 3px;
}
</style>
